
import { defineComponent } from 'vue'
import ZIcon from '~/components/zeal/ZIcon/ZIcon.vue'

export default defineComponent({
  name: 'OnboardStatusCard',
  components: {
    ZIcon
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    isComplete: {
      type: Boolean,
      default: false
    },
    showAction: {
      type: Boolean,
      default: false
    },
    actionLabel: {
      type: String,
      default: ''
    },
    actionHref: {
      type: String,
      default: ''
    },
    actionTo: {
      type: [String, Object],
      default: null
    },
    actionTarget: {
      type: String,
      default: ''
    },
    actionIcon: {
      type: String,
      default: ''
    }
  },
  computed: {
    actionComponent(): string {
      return this.actionTo ? 'nuxt-link' : 'a'
    },
    actionRel(): string | null {
      if (this.actionTarget === '_blank') {
        return 'noopener noreferrer'
      }
      return null
    },
    resolvedActionIcon(): string {
      if (this.actionIcon) return this.actionIcon
      return this.actionTarget === '_blank' ? 'arrow-up-right' : 'arrow-right'
    }
  }
})
